import { request } from '../../request';
import { User } from 'types/users';
import { PaginatedResponse } from 'services/api/types';
import { Withdrawal } from 'types/withdrawal';
import { Invoice } from 'types/invoices';
import { Statistics } from 'types/statistics';
import { AddInvoiceFormData } from 'view/pages/AdminUsers/components/AddInvoiceModal';

export const getUserInfo = async (userId: string): Promise<User> => {
  const { data } = await request({
    url: `/admin/users/${userId}`,
  });

  return data;
};

export const deleteUser = async (userId: string): Promise<void> => {
  await request({
    method: 'delete',
    url: `/admin/users/${userId}`,
  });

  return;
};

export const getUserStatistics = async (
  userId: string,
): Promise<Statistics> => {
  const { data } = await request({
    url: `/admin/users/${userId}/statistics`,
  });

  return data;
};

export const listUsers = async ({
  searchQuery = '',
  page = 1,
  orderBy = '',
  orderDirection = 'ASC',
  filters = {},
  url = '/admin/users',
}): Promise<PaginatedResponse<User>> => {
  const { data } = await request({
    url,
    params: {
      page,
      orderBy,
      orderDirection,
      ...(searchQuery.trim() && { searchQuery: searchQuery.trim() }),
      ...(page && { page }),
      ...(filters && { filters }),
    },
  });
  return data;
};

export const listWithdrawals = async (
  { searchQuery = '', page = 1, orderBy = '', orderDirection = 'ASC' },
  userId: string,
): Promise<PaginatedResponse<Withdrawal>> => {
  const { data } = await request({
    url: `/admin/users/${userId}/withdrawals`,
    params: {
      page,
      orderBy,
      orderDirection,
      ...(searchQuery.trim() && { searchQuery: searchQuery.trim() }),
      ...(page && { page }),
    },
  });
  return data;
};

export const listInvoices = async (
  { searchQuery = '', page = 1, orderBy = '', orderDirection = 'ASC' },
  userId: string,
): Promise<PaginatedResponse<Invoice>> => {
  const { data } = await request({
    url: `/admin/users/${userId}/invoices`,
    params: {
      page,
      orderBy,
      orderDirection,
      ...(searchQuery.trim() && { searchQuery: searchQuery.trim() }),
      ...(page && { page }),
    },
  });
  return data;
};

export const removeUserInvoice = async (
  userId: string,
  invoiceId: string,
): Promise<void> => {
  await request({
    method: 'delete',
    url: `/admin/users/${userId}/invoices/${invoiceId}`,
  });

  return;
};

export const createUserInvoice = async (
  userId: string,
  form: AddInvoiceFormData,
): Promise<Invoice> => {
  const { data } = await request({
    method: 'post',
    url: `/admin/users/${userId}/invoices`,
    data: form,
  });

  return data;
};

export const removeUserWithdrawal = async (
  userId: string,
  withdrawalId: string,
): Promise<void> => {
  await request({
    method: 'delete',
    url: `/admin/users/${userId}/withdrawals/${withdrawalId}`,
  });

  return;
};

export const processUserWithdrawal = async (
  userId: string,
  withdrawalId: string,
): Promise<void> => {
  await request({
    method: 'post',
    url: `/admin/users/${userId}/withdrawals/${withdrawalId}`,
  });

  return;
};

export const updateUserWithdrawal = async (
  userId: string,
  withdrawalId: string,
  data: Partial<Withdrawal>,
): Promise<void> => {
  await request({
    method: 'put',
    url: `/admin/users/${userId}/withdrawals/${withdrawalId}`,
    data,
  });

  return;
};

export const updateUser = async (
  userId: string,
  update: Partial<User>,
): Promise<User> => {
  const { data } = await request({
    method: 'put',
    url: `/admin/users/${userId}`,
    data: update,
  });

  return data;
};
